/* ACTION TYPES */

export const UPDATE_SELECTED_PAYMENT_OPTION = 'event-guestside-site/partialPayments/UPDATE_SELECTED_PAYMENT_OPTION';
export const UPDATE_PAYMENT_AMOUNT = 'event-guestside-site/partialPayments/UPDATE_PAYMENT_AMOUNT';
